/***
 * Copyright (c) Myia 2023-2025 - All Rights Reserved
 */
import { FC, PropsWithChildren, useState } from 'react';

import { Button } from '@/components/atoms/Button';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';

export const LiveAgentRunInformationPopover: FC<PropsWithChildren> = ({ children }) => {
    const [open, setOpen] = useState(false);
    return (
        <Popover open={open} onOpenChange={setOpen}>
            <PopoverTrigger>
                <Button size="small" theme="default" color="slate" onClick={() => setOpen(!open)}>
                    Run information
                </Button>
            </PopoverTrigger>

            <PopoverContent className={'w-[500px] p-0'}>
                <div>
                    <div className="px-4 py-3 flex items-center text-slate-700 gap-1 border-b font-medium leading-6">
                        Run information
                    </div>
                    <div className="py-1 px-2">{children}</div>
                </div>
            </PopoverContent>
        </Popover>
    );
};
